import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { COURSE_DETAILS_GET } from '../../../../app/redux/actions/coursedetails';
import ActivityCard from '../../ActivityCard';
import { HtmlRaw, Icon, Text } from '../../../atoms';
import VideoScorm from '../../VideoScorm';
import theme from '../../../theme';
import { ActivityCardContainer, SectionContainer } from './style';
import { Quiz } from '../..';

const CourseActivities = ({ sections = [], getCourseDetails }) => {
  const { course_id } = useParams();
  const [selectedActivity, setSelectedActivity] = useState();
  const [module, setModule] = useState({});

  useEffect(() => {
    // handle finishScorm
    window.addEventListener('message', receive, false);
    return () => {
      window.removeEventListener('message', receive);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const allActivities = [];
    (sections || []).forEach((s) => {
      allActivities.push(...s.activities);
    });
    if (allActivities?.length === 1) setModule(allActivities[0]);
  }, [sections]);

  const receive = (event) => {
    const { data: eventData } = event;
    //sendData function is generated by an opigno-scorm patch of the file opigno_scorm.player.js in the backend.
    //sendData send to the FE the cmi_data of the Scorm.
    if (eventData?.func === 'sendData') {
      if (
        eventData.params[0].cmi.completion_status === 'completed' ||
        eventData.params[0].cmi.completion_status === 'passed' ||
        eventData.params[0].cmi.core.lesson_status === 'completed' ||
        eventData.params[0].cmi.core.lesson_status === 'passed'
      ) {
        setTimeout(() => handleOnCompleted(), 1000);
      }
    }
  };

  const handleOnCompleted = () =>
    getCourseDetails({ id: course_id, hideLoader: true });

  const onClickLOItem = (item) => {
    if (!item?.data) return;
    if (selectedActivity?.id === item?.id) setSelectedActivity();
    else setSelectedActivity(item);
  };

  const isActiveItem = (itemId) => {
    if (!itemId || !selectedActivity?.id) return false;
    return itemId.toString() === selectedActivity.id.toString();
  };

  const isModule = () => {
    const allActivities = [];
    (sections || []).forEach((s) => {
      allActivities.push(...s.activities);
    });
    return allActivities?.length === 1;
  };

  if (isModule()) {
    return (
      <ActivityCardContainer>
        {module?.title && (
          <Text type="h2" mb={8}>
            {module?.title}
          </Text>
        )}
        <div className="code-status">
          <Text type="b3" color={theme().colors.placeholder} mb={30}>
            {module?.code}
          </Text>
          <div className="status">
            {module?.completion_status === 'completed' && (
              <Text type="b3">
                Attività completata <Icon type="check-circle" size={20} />
              </Text>
            )}
          </div>
        </div>
        {module?.description && (
          <div className="description">
            <Text type="h3" mb={8}>
              Descrizione attività
            </Text>
            <Text type="b3" mb={20}>
              <HtmlRaw html={module.description} />
            </Text>
          </div>
        )}
        {module?.type === 'activity_scorm' ? (
          <VideoScorm
            selectedActivity={module}
            handleOnCompleted={handleOnCompleted}
          />
        ) : module?.type === 'activity_quiz' ? (
          <Quiz
            data={module?.data}
            handleOnCompleted={handleOnCompleted}
            activity_id={module?.id}
            duration={module?.duration}
            isCompleted={module?.completion_status === 'completed'}
          />
        ) : null}
      </ActivityCardContainer>
    );
  }
  let counter = 0;
  return (sections || []).map((section, index) => (
    <SectionContainer key={`section-${index}`}>
      {section?.section_title && (
        <Text
          type="h1.5"
          mb={24}
          className={index === 0 ? '' : 'section-title'}
        >
          {section?.section_title}
        </Text>
      )}
      {(section?.activities || []).map((item) => (
        <ActivityCard
          key={item?.id}
          index={(counter += 1)}
          item={item}
          isActive={isActiveItem(item?.id)}
          onClick={() => onClickLOItem(item)}
          handleOnCompleted={handleOnCompleted}
        />
      ))}
    </SectionContainer>
  ));
};

CourseActivities.propTypes = {
  sections: PropTypes.array.isRequired,
  getCourseDetails: PropTypes.func,
};

export default connect(
  (state) => {
    const { sections } = state.coursedetails;
    const { data: relatedCourses } = state.courselist;
    return {
      sections,
      relatedCourses,
    };
  },
  (dispatch) => ({
    getCourseDetails: ({ id, hideLoader }) =>
      dispatch({ type: COURSE_DETAILS_GET._REQUEST, id, hideLoader }),
  })
)(CourseActivities);
